import React from 'react';
import Relay from 'react-relay';
import { style } from 'glamor';

import Link from 'depop/components/Link';

import { FAMILY_STANDARD_BOLD } from 'depop/styles/typography';

import { UserPicture } from 'depop/components/images';

class CommentListItem extends React.Component {
  props: {
    comment: Object,
  };

  render() {
    const { comment } = this.props;
    const { user } = comment;

    if (!user) {
      return null;
    }

    return (
      <p
        {...style({
          fontSize: 14,
          marginBottom: '.5em',
          maxWidth: '40em',
          lineHeight: '1.2',
        })}>
        <Link
          {...style({
            fontWeight: 'bold',
            textDecoration: 'none',
            color: 'inherit',
            fontFamily: FAMILY_STANDARD_BOLD,
          })}
          to={{
            pathname: `/${user.username}`,
            state: { userId: user.publicId },
          }}>
          {user.username}
        </Link>
        <span {...style({ fontWeight: 'normal' })}> {comment.content}</span>
      </p>
    );
  }
}

export default Relay.createContainer(CommentListItem, {
  fragments: {
    comment: () => Relay.QL`
      fragment on ProductComment {
        id
        content
        user {
          ${UserPicture.getFragment('user')}
          publicId
          username
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/comments/CommentListItem.js